<template>
    <b-card no-body>
        <b-modal id="upload" title="Luca Dosyası Yükle" no-close-on-esc no-close-on-backdrop>
            <luca-upload-file v-model="uploadObject" :years="years" :months="months"></luca-upload-file>
            <template #modal-footer><v-executer :disabled="!uploadObject.File" :loading="loading" text="Yükle" :action="upload"></v-executer></template>
        </b-modal>

        <v-table    ref="table"
                    :items-provider="provider"
                    pagination="server"
                    search
                    :fields="fields">
                        <template #additional-actions>
                            <div class="row">
                                <div class="col-md-2 mb-1 mb-md-0">
                                    <v-select-list :options="months" label="name" placeholder="Ay" v-model="c_month"></v-select-list>
                                </div>
                                <div class="col-md-2 mb-1 mb-md-0">
                                    <v-select-list :options="years" placeholder="Yıl" v-model="year"></v-select-list>
                                </div>
                                <div class="col-md-auto mb-1 mb-md-0">
                                    <button class="btn btn-success w-100" v-on:click="$refs.table.refresh()">
                                        Sorgula
                                    </button>
                                </div>
                                <div class="col-md-auto mb-1 mb-md-0">
                                    <button class="btn btn-primary" v-on:click="showUploader">Dosya Yükle</button>
                                </div>
                            </div>
                        </template>
                </v-table>
    </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue';
import moment from 'moment'
import EmployeeOperationsApi from '@/api/employee-operations'
import LucaUploadFile from './components/LucaUploadFile.vue'
import Additional from '@/utilities/additional'

export default {
    components:{
        BCard,
        LucaUploadFile
    },
    data(){
        return {
            years:[],
            month:Number(moment().month() + 1),
            year: Number(moment().format('YYYY')),
            months:[
                {index:1,name:'Ocak'},
                {index:2,name:'Şubat'},
                {index:3,name:'Mart'},
                {index:4,name:'Nisan'},
                {index:5,name:'Mayıs'},
                {index:6,name:'Haziran'},
                {index:7,name:'Temmuz'},
                {index:8,name:'Ağustos'},
                {index:9,name:'Eylül'},
                {index:10,name:'Ekim'},
                {index:11,name:'Kasım'},
                {index:12,name:'Aralık'}
            ],
            uploadObject:{
                Month:null,
                Year:null,
                File:null,
            },
            fields:[
                {name:'Personel', key:'FullName'},
                {name:'Personel', key:'IdentityNumber'},
                {name:'Netsis Net', key:'NetsisNet'},
                {name:'Luca Net', key:'LucaNet',sortable:true},
                {name:'Net Fark', key:'NetFark'},
                {name:'Net Eşleşti', key:'NetEslesti'},
                {name:'Netsis Brüt', key:'NetsisBrut'},
                {name:'Luca Brüt', key:'LucaBrut',sortable:true},
                {name:'Brüt Fark', key:'BrutFark'},
                {name:'Brüt Eşleşti', key:'BrutEslesti'},
                {name:'Sonuç', key:'Sonuc'},
            ],
            loading:false
        }
    },
    mounted(){
        this.configureYears()
    },
    methods:{
        clear(){
            this.uploadObject.Month = null
            this.uploadObject.Year = null
            this.uploadObject.File = null
        },
        showUploader(){
            this.clear()
            this.$showModal('upload')
        },
        configureYears(){  
            let years = []
            let year = moment().add(1,'year').format('YYYY')
            let firstYear = 1900
            while (firstYear <= year){
                years.push(firstYear++)
            }
            this.years = years.reverse()
        },
        provider(data){
            return EmployeeOperationsApi.Employee.LucaMatch({
                Month:this.month,
                Year:this.year,
                PaginationRequest:data
            })
        },
        async upload(){
            this.loading = true
            let formData = await Additional.ToFormData(this.uploadObject,['File'])
            EmployeeOperationsApi.Employee.LucaImport(formData).then(res=>{
                this.$result(res)
                this.loading = false
                if(res.data.Success){
                    this.$refs.table.refresh()
                    this.$hideModal('upload')
                }
            }).catch(err=>{
                this.loading = false
                this.$result(null,err)
            })
        }
    },
    computed:{
        c_month:{
            get:function(){
                return this.months.find(s=>s.index==this.month)
            },
            set:function(value){
                this.month = value?.index || null
            }
        }
    }
}
</script>